import { render, staticRenderFns } from "./retrievalSetting.vue?vue&type=template&id=2c332761&scoped=true&"
import script from "./retrievalSetting.vue?vue&type=script&lang=js&"
export * from "./retrievalSetting.vue?vue&type=script&lang=js&"
import style0 from "./retrievalSetting.vue?vue&type=style&index=0&id=2c332761&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c332761",
  null
  
)

export default component.exports